import React, { useState } from "react";
import PropTypes from "prop-types";
import Courses from "./Courses";
import LetterMark from "./LetterMark";
import Units from "./Units";
import CloseList from "./CloseList";



const GradeList = ({ grades, courses, letters, units, close, computeGrades, removeGrade, changeNames }) => {

  // let courseList = [];
  // let letterList = [];
  // let unitList = [];
  // let closeList = [];
  // if ({ grades }) {
  //   for (let grade of grades) {
  //     courseList.push(grade[0]);
  //     letterList.push(grade[3]);
  //     unitList.push(grade[2]);
  //     closeList.push("");
  //   }
  // }
  return (
    <div className="grades-list">
      <Courses courseList={courses} changeNames = {changeNames} />
      <LetterMark computeGrades = {computeGrades} letterMarkList={letters}/>
      <Units computeGrades = {computeGrades} unitList={units}/>
      <CloseList closeList={close} removeGrade  = {removeGrade} />
    </div>
  );
};

GradeList.propTypes = {};

export default GradeList;
